import o from "react";
import { Tooltip as t } from "./Tooltip.js";
const a = o.memo(t);
export {
  a as default
};
